import { Routes, Route, Navigate } from 'react-router-dom'

import ProductsListView from 'Presentation/Views/Products/Lists/View'
import ProductFormView from 'Presentation/Views/Products/Form/View'

const ProductsRoutes = () => (
	<Routes>
		{/* Route: Products List */}
		<Route path="all" element={<ProductsListView />} />
		{/* Route: Products List */}

		{/* Route: New Product */}
		<Route path="new" element={<ProductFormView />} />
		{/* Route: New Product */}

		{/* Route:: Product Detail */}
		<Route path=":id" element={<ProductFormView />} />
		{/* Route:: Product Detail */}

		{/* Route: Products Default */}
		<Route index element={<Navigate to="/products/all" />} />
		<Route path="*" element={<Navigate to="/oem/orders" />} />
	</Routes>
)

export default ProductsRoutes
